import { Chance } from "chance"
import { ExtractPatient } from "etl/types";

const chance = new Chance();

export const extractPatientFactoryMock = (howMany: number): ExtractPatient[] =>
	Array.from({ length: howMany }).map((_, index) => ({
		"@id": `/extract_patients/${index + 1}`,
		id: index + 1,
		first_name: chance.name().split(' ')[0],
		last_name: chance.name().split(' ')[1],
		birth_date: chance.birthday().toISOString(),
		email: chance.email(),
		phone: chance.phone().toString(),
		phone_mobile: chance.phone().toString(),
		id_secu: chance.word(),
		created_at: chance.date().toISOString(),
	}));
